
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M23.65 5.34 8.46 10.46v12.56c0 10.76 15.14 19.6 15.23 19.65l-.04-37.33Z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-Vector",attrs:{"d":"M24.157 45.085c-.21.131-.38.236-.506.312a51.758 51.758 0 0 1-2.472-1.635 55.748 55.748 0 0 1-6.012-4.874C10.771 34.758 6.5 29.178 6.5 23.15V8.92l17.152-5.773L41.15 8.922V23.16c0 5.974-4.353 11.55-8.84 15.693a57.407 57.407 0 0 1-8.153 6.232Z","stroke":"#234652"}})])
          )
        }
      }
    